import { RouteNames } from '@/data/routes';
import Maintenance from '@/pages/maintenance/MaintenanceIndexPage.vue';
import { createRoutes } from '@/utils/router-helper';

export default createRoutes({
  path: '/maintenance',
  name: RouteNames.MAINTENANCE.INDEX,
  component: Maintenance,
});
